module.exports = __webpack_public_path__ + "files/b0263cbe57ea89c123240c0b5556476d.png";